import Pagination from 'components/Pagination';
import React, { useState } from 'react';
import BeSafeCard from './BeSafeCard';
import BeSafeContainer from './BeSafeContainer';
import { FormattedMessage } from 'react-intl';
import BeSafeSearchBar from './BeSafeSearchBar';
import AdvancedFilter from '../AdvancedFilter/AdvancedFilter';

const BeSafeTableCard = (props) => {
  const perPageValues = props.perPageValues;
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(perPageValues[0]);

  const onSearch = (query) => {
    setPageNumber(1);
    props.onSearch(query);
  };

  const handlePageChange = (pageNum) => {
    setPageNumber(pageNum);
    props.onPageChange(pageNum);
  };

  const handlePerPageChange = (itemsPerPage) => {
    setPerPage(itemsPerPage);
    props.onPerPageChange(itemsPerPage);
  };

  const footerMessage = () => {
    if (props.footerMessage) {
      return props.footerMessage;
    }
    return <FormattedMessage id="GENERAL.TOTAL" />;
  };

  return (
    <BeSafeCard
      title={props.title}
      buttons={props.buttons}
      className={props.className}
    >
      <div className="d-flex justify-content-between align-items-center">
        <BeSafeSearchBar visible={props.withSearch} onSearch={onSearch} />

        <div className="d-flex align-items-center">
          {props.withFilters && (
            <AdvancedFilter
              filters={props.onFilters.filters}
              handlerFiltersChange={props.onFilters.handlerFilters}
              defaultFilters={props.onFilters.defaultFilters}
            />
          )}
        </div>
      </div>

      <BeSafeContainer>
        {props.children}
        <div className="mt-3 d-flex justify-content-between">
          {props.itemCount >= 0 && (
            <div>
              <span className="text-primary align-sub">
                <b>{footerMessage()}: </b>
                {props.itemCount}
              </span>
            </div>
          )}
          {props.withPagination && (
            <Pagination
              totalItems={props.itemCount}
              handlePageChange={handlePageChange}
              pageNumber={pageNumber}
              perPage={perPage}
              handlePerPageChange={handlePerPageChange}
              perPageValues={props.perPageValues}
            />
          )}
        </div>
      </BeSafeContainer>
    </BeSafeCard>
  );
};

BeSafeTableCard.defaultProps = {
  withSearch: false,
  onSearch: () => {},
  perPageValues: [10, 50, 100],
};

export default BeSafeTableCard;
